var _rect, _circle, _path, _g, _g2, _g3, _g4, _g5, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrokerSupportIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 520 344",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 520,
    height: 344,
    rx: 16,
    fill: "#E8F2FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 264.309,
    cy: 177.941,
    r: 81.8913,
    stroke: "#E8F2FF",
    strokeWidth: 49.8055
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M166.932 249.66C78.7983 136.059 56.524 70.2696 141.505 111.417C265.747 171.576 568.764 394.742 345.127 99.0726",
    stroke: "#002D9C",
    strokeWidth: 4,
    strokeDasharray: "5.21 5.21"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_91_5194)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 264.308,
    cy: 177.941,
    r: 31.2568,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_91_5194)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.6473,
    height: 34.6473,
    transform: "translate(246.974 161.141)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.779 174.458C248.779 169.295 252.832 165.11 257.831 165.11C260.364 165.11 262.655 166.185 264.298 167.916C265.941 166.185 268.231 165.11 270.764 165.11C275.764 165.11 279.817 169.295 279.817 174.458C279.817 184.962 269.297 189.147 264.298 191.818C259.298 189.147 248.779 184.962 248.779 174.458Z",
    fill: "#62A1FE"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_91_5194)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.9084,
    y: 179.243,
    width: 132.154,
    height: 132.154,
    rx: 66.0772,
    fill: "#001D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.166 263.672C130.166 254.363 137.712 246.817 147.021 246.817H167.89C177.2 246.817 184.746 254.363 184.746 263.672C184.746 266.775 182.231 269.291 179.128 269.291H135.784C132.681 269.291 130.166 266.775 130.166 263.672Z",
    fill: "#A6C8FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.457,
    cy: 227.553,
    r: 14.4478,
    fill: "#A6C8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.858 271.674L196.858 271.674C198.122 270.715 198.727 269.121 198.472 267.569L197.201 259.836C197.159 259.583 197.241 259.325 197.42 259.143L202.788 253.683L202.788 253.683C203.897 252.555 204.279 250.894 203.812 249.392L203.812 249.392C203.342 247.884 202.074 246.737 200.491 246.497L200.491 246.497L193.156 245.385C192.892 245.345 192.665 245.176 192.55 244.935L189.251 237.96L187.804 238.644L189.251 237.96C188.575 236.528 187.151 235.579 185.546 235.579C183.942 235.579 182.518 236.528 181.841 237.96L181.841 237.96L178.542 244.935L179.993 245.621L178.542 244.935C178.428 245.176 178.201 245.345 177.937 245.385L170.602 246.497L170.602 246.497C169.454 246.671 168.467 247.325 167.836 248.245C167.598 248.593 167.41 248.978 167.281 249.392L167.281 249.392C166.813 250.894 167.196 252.555 168.305 253.683L168.305 253.683L173.673 259.143C173.752 259.224 173.812 259.319 173.851 259.422C173.9 259.552 173.915 259.695 173.892 259.836L172.621 267.569L172.621 267.569C172.366 269.121 172.971 270.715 174.235 271.674L174.235 271.674C174.953 272.218 175.813 272.501 176.683 272.501C177.35 272.501 178.018 272.334 178.624 272.002L177.852 270.594L178.624 272.002L185.16 268.416C185.401 268.284 185.692 268.284 185.932 268.416L192.469 272.002C193.075 272.334 193.743 272.501 194.41 272.501C195.28 272.501 196.14 272.218 196.858 271.674Z",
    fill: "white",
    stroke: "#001D6C",
    strokeWidth: 3.21061
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_91_5194)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 283.845,
    y: 33.3785,
    width: 132.151,
    height: 132.151,
    rx: 66.0756,
    fill: "#0078FF",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M363.109 93.9852C359.334 95.7627 356.928 99.5366 356.928 103.681C356.953 109.552 361.73 114.313 367.65 114.368C373.569 114.422 378.434 109.75 378.569 103.88C378.576 103.812 378.58 103.745 378.58 103.677C378.58 103.633 378.578 103.589 378.576 103.546V86.7351H378.56C378.671 85.9687 378.32 85.2088 377.663 84.7904C377.006 84.372 376.164 84.372 375.507 84.7904C374.85 85.2088 374.5 85.9687 374.61 86.7351H374.591V95.3638C371.353 92.7444 366.883 92.2077 363.109 93.9852ZM367.75 110.461C363.975 110.461 360.914 107.425 360.914 103.681C360.915 99.9366 363.975 96.9018 367.75 96.9005C371.526 96.9005 374.587 99.9361 374.587 103.681C374.587 107.425 371.526 110.461 367.75 110.461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333.007 103.682C333.007 97.7539 337.852 92.9485 343.829 92.9485C349.805 92.9485 354.651 97.7539 354.651 103.682C354.651 109.609 349.805 114.415 343.829 114.415C337.852 114.415 333.007 109.609 333.007 103.682ZM336.991 103.681C336.991 107.425 340.051 110.461 343.827 110.461C347.602 110.46 350.662 107.425 350.664 103.681C350.664 99.9365 347.603 96.9009 343.828 96.9008C340.052 96.9007 336.991 99.9361 336.991 103.681Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.082 103.681C312.082 99.3916 314.657 95.5141 318.63 93.82C322.604 92.126 327.212 92.9409 330.351 95.8923L330.338 95.8963C330.867 96.3945 331.079 97.1402 330.891 97.8394C330.702 98.5386 330.142 99.0793 329.433 99.2484C328.723 99.4175 327.977 99.1879 327.488 98.6502C324.739 96.1824 320.507 96.338 317.95 99.001C315.393 101.664 315.442 105.863 318.061 108.467C320.68 111.07 324.914 111.129 327.605 108.598L327.644 108.64C328.005 108.303 328.483 108.114 328.979 108.114C330.085 108.128 330.971 109.028 330.958 110.125C330.963 110.913 330.504 111.631 329.783 111.963C326.551 114.604 322.073 115.158 318.286 113.386C314.499 111.614 312.083 107.834 312.082 103.681Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.367 112.456C383.367 112.355 383.374 112.254 383.39 112.154H383.367V94.9351C383.368 93.8424 384.262 92.9575 385.364 92.9586C386.465 92.9597 387.358 93.8464 387.356 94.9391C387.356 94.983 387.355 95.0265 387.352 95.0696V112.154H387.334C387.446 112.888 387.136 113.622 386.529 114.057C385.922 114.491 385.121 114.552 384.455 114.214C383.788 113.877 383.368 113.198 383.367 112.456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.359 90.807C386.551 90.807 387.517 89.849 387.517 88.6673C387.517 87.4856 386.551 86.5276 385.359 86.5276C384.168 86.5276 383.201 87.4856 383.201 88.6673C383.201 89.849 384.168 90.807 385.359 90.807Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_91_5194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.538 243.752C324.221 242.817 323.025 242.817 322.707 243.752L319.968 251.824C317.771 258.296 312.605 263.487 305.907 265.955C305.015 266.283 305.015 267.676 305.907 268.004C312.606 270.471 317.771 275.663 319.968 282.135L322.707 290.207C323.025 291.141 324.221 291.141 324.538 290.207L327.255 282.201C329.462 275.698 334.652 270.483 341.382 268.004C342.274 267.676 342.274 266.283 341.382 265.955C334.652 263.476 329.462 258.261 327.255 251.758L324.538 243.752Z",
    fill: "#0078FF"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_91_5194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.833 69.3342C231.563 68.5307 230.542 68.5307 230.272 69.3342L227.935 76.2742C226.062 81.8384 221.656 86.3013 215.942 88.4225C215.182 88.7047 215.182 89.9023 215.942 90.1845C221.656 92.3057 226.062 96.7686 227.935 102.333L230.272 109.273C230.542 110.076 231.563 110.076 231.833 109.273L234.151 102.39C236.033 96.7994 240.46 92.3156 246.201 90.1845C246.961 89.9023 246.961 88.7047 246.201 88.4225C240.46 86.2914 236.033 81.8076 234.151 76.2173L231.833 69.3342Z",
    fill: "#001D6C"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M200.634 51.7251C200.485 51.3022 199.922 51.3022 199.772 51.7251L198.483 55.3777C197.449 58.3063 195.019 60.6552 191.866 61.7716C191.447 61.9201 191.447 62.5504 191.866 62.699C195.019 63.8154 197.449 66.1643 198.483 69.0929L199.772 72.7454C199.922 73.1683 200.485 73.1683 200.634 72.7454L201.913 69.1228C202.951 66.1805 205.393 63.8206 208.561 62.699C208.98 62.5504 208.98 61.9201 208.561 61.7716C205.393 60.65 202.951 58.2901 201.913 55.3478L200.634 51.7251Z",
    fill: "#0078FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.907 122.134C131.748 121.669 131.15 121.669 130.992 122.134L129.622 126.152C128.523 129.374 125.941 131.957 122.591 133.185C122.145 133.349 122.145 134.042 122.591 134.206C125.941 135.434 128.523 138.017 129.622 141.239L130.991 145.257C131.15 145.722 131.748 145.722 131.907 145.257L133.265 141.272C134.369 138.035 136.964 135.439 140.329 134.206C140.775 134.042 140.775 133.349 140.329 133.185C136.964 131.952 134.369 129.356 133.266 126.119L131.907 122.134Z",
    fill: "#A6C8FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M424.244 162.195C424.085 161.73 423.487 161.73 423.328 162.195L421.959 166.213C420.86 169.435 418.277 172.018 414.928 173.246C414.482 173.41 414.482 174.103 414.928 174.266C418.278 175.494 420.86 178.078 421.959 181.3L423.328 185.317C423.487 185.783 424.085 185.783 424.244 185.317L425.602 181.333C426.706 178.096 429.301 175.5 432.666 174.266C433.112 174.103 433.112 173.41 432.666 173.246C429.301 172.013 426.706 169.417 425.602 166.18L424.244 162.195Z",
    fill: "#001D6C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_91_5194",
    x: 220.059,
    y: 136.939,
    width: 88.4992,
    height: 88.499,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.24819
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.49637
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_91_5194"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_91_5194",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_91_5194",
    x: 83.2801,
    y: 168.824,
    width: 163.411,
    height: 163.411,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.20947
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8142
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_91_5194"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_91_5194",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_91_5194",
    x: 268.216,
    y: 22.9596,
    width: 163.408,
    height: 163.408,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.20947
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8142
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_91_5194"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_91_5194",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_91_5194",
    x: 290.513,
    y: 235.688,
    width: 66.263,
    height: 77.3068,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.36256
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.36256
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_91_5194"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_91_5194",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_91_5194",
    x: 200.646,
    y: 61.369,
    width: 60.8494,
    height: 70.5939,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.36256
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.36256
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_91_5194"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_91_5194",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_91_5194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.6473,
    height: 34.6473,
    fill: "white",
    transform: "translate(246.974 161.141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokerSupportIllustration);
export default __webpack_public_path__ + "static/media/broker-support-illustration.79e8db25963d055923ae090b7159e07e.svg";
export { ForwardRef as ReactComponent };